(function () {
  'use strict';

  angular.module('sempraWebapp').provider('broker', webSocketProvider);

  /** @ngInject */
  function webSocketProvider () {
    this.$get = ['webSocketService', 'webSocketMock', 'useMqttBroker', function (webSocketService, webSocketMock, useMqttBroker) {
      if (useMqttBroker) {
        return webSocketService;
      } else {
        return webSocketMock;
      }
    }];
  }
})();
